import ET3Div from "../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import KhattabaMenu from "./KhattabaAdmin";

// Khattaba-only client: the header menu always shows the khattaba menu.
const HeaderMenu = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={1270}
      height={95}
      fDirection="column"
      alignItems="center"
      justifyContent="flex-end"
      color={colors.all.transparent}
      style={{}}
      onClick={() => { }}
    >
      <KhattabaMenu />
    </ET3Div>
  );
});

export default HeaderMenu;
